import Vue from 'vue'
import Payment from './Payment.vue'
import vuetifyNsuk from "../plugins/vuetify";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import urlUtil from "@/utils/urlUtil";


// set default api
// set default api
axios.defaults.baseURL = urlUtil.getBaseUrl();


Vue.config.productionTip = false;
Vue.use(VueToast);

new Vue({
    vuetify: vuetifyNsuk,
    render: (h) => h(Payment),
}).$mount("#app");
